import { Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import styles from "../textMessage/textMessage.module.scss";
import ChatLike from "../chatLike";
import ChatHoverOption from "../chatHoverOption";
import ChatUserInfo from "../chatUserInfo";
import ChatLeftInfo from "../chatLeftInfo";
import ChatRightInfo from "../chatRightInfo";
import moment from "moment";
import store from "../../../../context/store/store";
import { useSelector } from "react-redux";
import { chats, chatwindowDetails, contacts, initialStateModel, workContact } from "../../../../models/model";
import { Types } from "../../../../context/action/action";
import { URCheckBoxCall } from "../../../../shared/widgets/checkBoxForCall/callCheckBox";
import { getTeamMembersnamelist, urlify } from "../../../../base/utils";
import ForwardHeader from "../forwardHeader";
import _ from "lodash";
import { SocketChatService } from "../../../../base/socketChatService";
import { generateChatID, userInfo } from "../../../../base/socketChatService/utils";
import { ChatService } from "../../../../base/chatService";
import { useHistory } from "react-router-dom";

type textMessageProps = {
  searchedData?: any;
  data:any;
  timeValue?:any;
  savedData?:any; 
}
export default function ChatMentionMessage({data,searchedData,savedData,timeValue}:textMessageProps) {
  let timeCount = timeValue !== undefined ? timeValue : 18;
  const chatReducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  let history=useHistory();
  const chatWindowReducer: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);
  const [longText, setlongtext] = useState(0);
  const { userdetails }: any = useSelector((state: initialStateModel) => state.loginReducer);
  let { id,  direction, timestamp, fromcaller_details } = data;
  let isReply = data.message?.isReply;
  let messageBody = data.message.body;
  const mention_mem:Array<any> = data?.message?.forward? getTeamMembersnamelist(data?.message?.mentionID): chatWindowReducer?.chatWindowDetails?.teammembersdetails || [];
  let message_text = messageBody;
  let message_text_search = "";
  let isBookmark:any = data?.message?.isSave;
  let widthMulti = (!data?.message?.isDelete && (!isBookmark || isBookmark["s" + userdetails?.sip_login_id]) === 1 ) && data?.message?.isEdit ?"saveEdited": 
  (!data?.message?.isDelete && (!isBookmark || isBookmark["s" + userdetails?.sip_login_id]) === 1 )?"onlySaved": data?.message?.isEdit ? "onlyEdited" : "widthDefault";
 
  mention_mem.map((value:any)=>{
    const callerID = value?.caller_id.toString();
    var re = new RegExp(`${"@"+(callerID)}`, 'g');
    message_text = message_text.replace(re,
      '<span class="textmsg atMention '+styles.atMention+'">@'+callerID+'</span>').replace(/<\/?a[^>]*>/g," ");
   
  });
  useEffect(() => {
    var focusableInputElements: any = document.querySelectorAll(".focusText");
    if (focusableInputElements.length > 0 && chatReducer.isSaveChat) {
      focusableInputElements[0].focus();
    }
    
  }, [savedData]);
  
  useEffect(() => {

  }, [searchedData]);
 try {
  let mstext = message_text ? message_text?.toString() : "";
  message_text_search = message_text;
  
  message_text_search= message_text_search
    .replace(/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\\/%?=~_|!:,.;]*[-A-Z0-9+&@#\\/%=~_|])/img,
      '<a href="$1" target="__blank">$1</a>');
  message_text_search = message_text_search?.replace(/\n/g, "<br />");
  if(searchedData!=="" && searchedData!== undefined){
    const regexs = new RegExp('('+searchedData+')', 'gi');
    message_text_search = message_text_search?.replace(regexs,
      '<span style="background-color:#FFFF00" tabindex="0" class="tranText">$1</span>');
  }

  if (mstext?.length > 760 && longText === 0) {
    message_text_search = mstext?.substring(0, 760) + "...";
  }
  const readMoreChange = ()=>{
    setlongtext(1);
  }
  let htimestamp = moment(timestamp).format('hh:mm A');

  const handleCheckBoxClick =()=>{
  
  };

  const handlehighlightHover =()=>{
    var element: HTMLElement | any = document.getElementById(id) || null;
    if (element != null) {
      element.classList.add("highlighthover");
    }
    
  };

  const handleOnChange =(e:any)=>{
    let deletedArray:any = chatReducer?.selectMessageData;
    let index = [];
    if (e.target.checked) {
      deletedArray?.push(data);
      store.dispatch({
        type: Types.SELECT_MESSAGE_ARRAY,
        payload: {
          selectMessageData:deletedArray
        }
      });
    } else {
      index = deletedArray?.indexOf(data);
      deletedArray?.splice(index, 1);
      store.dispatch({
        type: Types.SELECT_MESSAGE_ARRAY,
        payload: {
          selectMessageData:deletedArray
        }
      });
    }
  };

  const atMentionRedirect=()=>{
    let contactReducer: contacts = store.getState().contactReducer || [];
    let companyContact: Array<workContact> = contactReducer.workContacts || [];
    let   contactDetail:any = _.find(companyContact, function (o) {
      return (o.sip_login_id.toString() === data.message.mentionID)
    });
  store.dispatch({
      type:Types.SET_CONTACT_WINDOW,
      payload:{chatWindowDetails:contactDetail}
  })
  const userDetails = userInfo();
  const id:any=generateChatID(userDetails.fromID, data.message.mentionID)
  ChatService.openChatWindow(contactDetail, history);
  const socketChat = new SocketChatService(userInfo().fromID, userInfo().domainId);
  socketChat.getChatHistory(id,"")
  }

  return (
    <>
     
      { direction === "IN" ? (
          <div className={`${chatReducer.isSaveChat &&
            id === savedData ? 'savedhighlight' : ""
            } ${styles.chatMsg} lftMessage ${styles.leftMessage}  ${(chatReducer?.multiOption && chatReducer?.selectMessageData?.indexOf(data) > -1 ) ? "checked" : chatReducer?.multiOption?"checking":""}`} id={id} onClick={handleCheckBoxClick}>
 
         { timeCount > 15 && <div className={`${styles.chatUserDetails}`}>
              <ChatUserInfo userDetails={fromcaller_details===undefined?'Unknown User':fromcaller_details} className='userinfoIcon leftSide' />
              <div className={styles.convMemName}><span>{fromcaller_details===undefined?'Unknown User':fromcaller_details?.caller_id}</span></div>
            </div>}
          <div className={styles.chatLeftMessages}>
            <div className={styles.chatLeft}>
              {!isReply  && <Tooltip  mouseEnterDelay={0.5} title={htimestamp} className='cusTooltip' overlayClassName='customTooltip'>
                <div className={styles.chatTime}>{htimestamp}</div></Tooltip>}
                <div className={`msgContentLft ${styles.chatContent}`}>
                {data?.message?.forward && <ForwardHeader />} 
                <div className="textContent">
                <span className={id === savedData ? "focusText" : ""} tabIndex={0} > 
                  <span dangerouslySetInnerHTML={{__html:urlify(message_text_search)}}></span>
                  </span>
                  {mstext?.length > 760 && longText === 0 && <span className="chatReadMore" onClick={() => readMoreChange()}>Read more</span>}
                  <span className={widthMulti}></span>
                </div>

                {/* {data?.message?.isEdit ? ( <span className={styles.editing} >(edited)</span> ):null} */}
                <div className={`chatInnerHoveroptn ${styles.hoverOptions}`}><ChatHoverOption className='hoverList hoverListleft' data={data} highlightHover={handlehighlightHover}/></div>
                <ChatLeftInfo userDetails = {fromcaller_details===undefined?'Unknown User':fromcaller_details} timeStamp = {timestamp} message={data}></ChatLeftInfo>
              </div>
            </div>
          </div>
          {!isReply  && <ChatLike className='likeLeft' placement="top"
                  tooltipTitle={data?.likeduserdetails}
                  message={data}/>}
          {(chatReducer?.isForward && !chatReducer?.isDelete ) && <URCheckBoxCall className="chatSelectRight"
              checked={chatReducer?.selectMessageData?.indexOf(data) > -1 ? true : false}  onChange={handleOnChange}/>}
        </div>
        
      ) : (
      <div onClick={handleCheckBoxClick} className={`${chatReducer.isSaveChat &&
            id === savedData ? 'savedhighlight' : ""
            } rtMessage ${styles.chatMsg} ${styles.rightMessage} 
            ${(chatReducer?.multiOption &&chatReducer?.selectMessageData?.indexOf(data) > -1 ) ? "checked" : chatReducer?.multiOption?"checking":""}`
          } id={id} >

          {!isReply  && timeCount >15 && <div className={`${styles.chatUserDetails}`}>
            <div className={styles.convMemName}><span>You</span></div>
            <ChatUserInfo userDetails = {fromcaller_details===undefined?'Unknown User':fromcaller_details} className='userinfoIcon rightSide'/>
          </div>}
          <div className={styles.chatRightMessages} >
            <div className={styles.chatRight} >
            <div className={`msgContentRT ${styles.chatContent}`}>
            {data?.message?.forward && <ForwardHeader />} 
                <div className="textContent">
                <span className={id === savedData ? "focusText" : ""} tabIndex={0} > 
                  <span dangerouslySetInnerHTML={{__html:urlify(message_text_search)}} onClick={()=> atMentionRedirect()}>
                  </span>
                  </span>
                  {mstext?.length > 760 && longText === 0 && <span className="chatReadMore" onClick={() => readMoreChange()}>Read more</span>}

                  <span className={widthMulti}></span>
                </div>
                {/* {!isReply  && data?.message?.isEdit ? ( <span className={styles.editing} >(edited)</span> ):null}
                  */}
                {!isReply  && <ChatRightInfo userDetails = {fromcaller_details===undefined?'Unknown User':fromcaller_details} timeStamp = {timestamp} message={data}></ChatRightInfo>}
                {!isReply  &&  <div className={`chatInnerHoveroptn ${styles.hoverOptions}`}><ChatHoverOption className='hoverList hoverListright' data={data} highlightHover={handlehighlightHover}/></div>}
              </div>
              {/* {!isReply  &&  <Tooltip mouseEnterDelay={0.5} placement="topRight" title={htimestamp}
                className='cusTooltip' overlayClassName='customTooltip'>
                <div className={styles.chatTime}>{htimestamp}</div></Tooltip>} */}
            </div>
          </div>
          
          {!isReply  && <ChatLike className='likeRight' placement="topRight"
                  tooltipTitle={data?.likeduserdetails} message={data}/>}
          {/* Need to handle */}
          {(chatReducer?.isDelete || chatReducer?.isForward || chatReducer?.multiOption ) &&<URCheckBoxCall
            checked={chatReducer?.selectMessageData?.indexOf(data) > -1 ? true : false}
            className="chatSelectRight" onChange={handleOnChange}/>}
        </div>
      )

      }
      
    </>
  );
} catch(e){
  return <p style={{color: 'red'}}>Something went wrong</p>;
}
};

